import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import ViewBooking from './ViewBooking';
import BookingServices from '../../services/BookingServices';

function ViewEarning({ investment, closeModal }) {
  // Move hooks to the top level
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [booking, setBooking] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);

  const handleViewDetails = (book) => {
    setSelectedUser(book);
    setIsModalOpen(true);
  };

  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const closeUserModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  function formatDateTime(isoString) {
    const date = new Date(isoString);
    const formattedDate = date.toLocaleDateString();
    const formattedTime = date.toLocaleTimeString();
    return { date: formattedDate, time: formattedTime };
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return 'N/A';
    }

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();

    return `${day}-${month}-${year}`;
  };



  useEffect(() => {
    if (!investment) return;
    const fetchBooking = async () => {
      try {
        const response = await BookingServices.getMyBookingById(investment._id);
        setBooking(response.data);
        console.log(response.data)
      } catch (error) {
        console.error('Error fetching booking:', error);
      }
    };
    fetchBooking();
  }, [investment]);

  if (!investment) return null;

  return (
    <div className="modal fade viewbox edit-box show d-block" tabIndex={-1} aria-labelledby="userModal" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div
          className="modal-content"
        >
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Detailed View
            </h5>
            <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
          </div>
          <div className="modal-body">

            <div className="container-box user-manager" style={{ padding: '10px', marginTop: '15px' }}>
              <p className="information-heading">Investor Information</p>
              <ul className="user-details list-unstyled d-flex justify-content-between">
                <li>
                  <span>Name</span>
                  <p>{investment?.property?.investor?.name || 'N/A'}</p>
                </li>
                <li>
                  <span>Phone</span>
                  <p>{investment?.property?.investor?.mobileNo || 'N/A'}</p>
                </li>
                <li>
                  <span>Email</span>
                  <p>{investment?.property?.investor?.email || 'N/A'}</p>
                </li>
              </ul>
              <ul className="user-details list-unstyled d-flex justify-content-between">
                <li>
                  <span>Property Name</span>
                  <p>{investment?.cottage?.name || 'N/A'}</p>
                </li>
                <li>
                  <span>Room Number</span>
                  <p>{investment?.room?.roomNumber || 'N/A'}</p>
                </li>
                <li>
                  <span>Investment Earning</span>
                  <p>{investment?.investorEarning || 'N/A'}</p>
                </li>
               
              </ul>
            </div>


            {/* <div className="col-sm-12">
              <div
                className="container-box  user-manager"
                style={{ padding: 10, marginTop: 15 }}
              >
                <ul
                  className="nav nav-pills mb-3"
                  id="pills-tab"
                  role="tablist"
                  style={{ gap: 10 }}
                >
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="pills-home-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-home"
                      type="button"
                      role="tab"
                      aria-controls="pills-home"
                      aria-selected="true"
                      style={{ width: "100%" }}
                    >
                      All
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="pills-profile-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-profile"
                      type="button"
                      role="tab"
                      aria-controls="pills-profile"
                      aria-selected="false"
                      style={{ width: "100%" }}
                    >
                      Earning
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="pills-contact-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-contact"
                      type="button"
                      role="tab"
                      aria-controls="pills-contact"
                      aria-selected="false"
                      style={{ width: "100%" }}
                    >
                      Payment
                    </button>
                  </li>
                  <li>
                    <button
                      className="excel-btn site-btn-green ms-3"
                     
                    >
                      <img src="img/excel-btn.svg" alt="" />
                      <span className="ms-2">Download</span>
                    </button>
                  </li>
                </ul>
                <div className="tab-content" id="pills-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="pills-home"
                    role="tabpanel"
                    aria-labelledby="pills-home-tab"
                  >
                    {" "}
                    <div className="booking-detail" style={{ marginTop: 20 }}>
                      <table
                        className="table table-striped"
                        style={{ border: "1px solid #FFFFFF", borderRadius: 10 }}
                      >
                        <thead style={{ backgroundColor: "#D9D9D9" }}>
                          <tr>
                            <th
                              style={{
                                backgroundColor: "#F9FAFF",
                                color: "#232859",
                                textTransform: "none",
                                fontSize: 16
                              }}
                            >
                              Payment History
                            </th>
                            <th
                              style={{
                                backgroundColor: "#F9FAFF",
                                color: "#232859",
                                textTransform: "none"
                              }}
                            ></th>
                            <th
                              style={{
                                backgroundColor: "#F9FAFF",
                                color: "#232859",
                                textTransform: "none"
                              }}
                            ></th>
                            <th
                              style={{
                                backgroundColor: "#F9FAFF",
                                color: "#232859",
                                textTransform: "none"
                              }}
                            ></th>
                            <th
                              style={{
                                backgroundColor: "#F9FAFF",
                                color: "#232859",
                                textTransform: "none"
                              }}
                            ></th>
                            <th
                              style={{
                                backgroundColor: "#F9FAFF",
                                color: "#232859",
                                textTransform: "none"
                              }}
                            ></th>
                          </tr>
                          <tr>
                            <th
                              style={{ color: "#fff", backgroundColor: "#8C8FA7" }}
                            >
                              Transaction ID
                            </th>
                            <th
                              style={{ color: "#fff", backgroundColor: "#8C8FA7" }}
                            >
                              Property Name
                            </th>
                            <th
                              style={{ color: "#fff", backgroundColor: "#8C8FA7" }}
                            >
                              Amount Paid
                            </th>
                            <th
                              style={{ color: "#fff", backgroundColor: "#8C8FA7" }}
                            >
                              Payment Date
                            </th>
                            <th
                              style={{ color: "#fff", backgroundColor: "#8C8FA7" }}
                            >
                              Payment Method
                            </th>
                            <th
                              style={{ color: "#fff", backgroundColor: "#8C8FA7" }}
                            >
                              Status
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr style={{ backgroundColor: "#F9FAFF" }}>
                            <td>#TXN001</td>
                            <td>Sunset Cottage</td>
                            <td>₹1 Crore</td>
                            <td>12 October 2024</td>
                            <td>Bank Transfer</td>
                            <td>Successful</td>
                          </tr>
                          <tr style={{ backgroundColor: "#F9FAFF" }}>
                            <td>#TXN002</td>
                            <td>Sunset Cottage</td>
                            <td>₹1 Crore</td>
                            <td>12 October 2024</td>
                            <td>Bank Transfer</td>
                            <td>Successful</td>
                          </tr>
                          <tr style={{ backgroundColor: "#F9FAFF" }}>
                            <td>#TXN003</td>
                            <td>Sunset Cottage</td>
                            <td>₹1 Crore</td>
                            <td>12 October 2024</td>
                            <td>Bank Transfer</td>
                            <td>Successful</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="pills-profile"
                    role="tabpanel"
                    aria-labelledby="pills-profile-tab"
                  >
                    {" "}
                    <table
                      className="table table-striped"
                      style={{ border: "1px solid #FFFFFF", borderRadius: 10 }}
                    >
                      <thead style={{ backgroundColor: "#D9D9D9" }}>
                        <tr>
                          <th
                            style={{
                              backgroundColor: "#F9FAFF",
                              color: "#232859",
                              textTransform: "none",
                              fontSize: 16
                            }}
                          >
                            Payment History
                          </th>
                          <th
                            style={{
                              backgroundColor: "#F9FAFF",
                              color: "#232859",
                              textTransform: "none"
                            }}
                          ></th>
                          <th
                            style={{
                              backgroundColor: "#F9FAFF",
                              color: "#232859",
                              textTransform: "none"
                            }}
                          ></th>
                          <th
                            style={{
                              backgroundColor: "#F9FAFF",
                              color: "#232859",
                              textTransform: "none"
                            }}
                          ></th>
                          <th
                            style={{
                              backgroundColor: "#F9FAFF",
                              color: "#232859",
                              textTransform: "none"
                            }}
                          ></th>
                          <th
                            style={{
                              backgroundColor: "#F9FAFF",
                              color: "#232859",
                              textTransform: "none"
                            }}
                          ></th>
                        </tr>
                        <tr>
                          <th style={{ color: "#fff", backgroundColor: "#8C8FA7" }}>
                            Transaction ID
                          </th>
                          <th style={{ color: "#fff", backgroundColor: "#8C8FA7" }}>
                            Property Name
                          </th>
                          <th style={{ color: "#fff", backgroundColor: "#8C8FA7" }}>
                            Amount Paid
                          </th>
                          <th style={{ color: "#fff", backgroundColor: "#8C8FA7" }}>
                            Payment Date
                          </th>
                          <th style={{ color: "#fff", backgroundColor: "#8C8FA7" }}>
                            Payment Method
                          </th>
                          <th style={{ color: "#fff", backgroundColor: "#8C8FA7" }}>
                            Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr style={{ backgroundColor: "#F9FAFF" }}>
                          <td>#TXN001</td>
                          <td>Sunset Cottage</td>
                          <td>₹1 Crore</td>
                          <td>12 October 2024</td>
                          <td>Bank Transfer</td>
                          <td>Successful</td>
                        </tr>
                        <tr style={{ backgroundColor: "#F9FAFF" }}>
                          <td>#TXN002</td>
                          <td>Sunset Cottage</td>
                          <td>₹1 Crore</td>
                          <td>12 October 2024</td>
                          <td>Bank Transfer</td>
                          <td>Successful</td>
                        </tr>
                        <tr style={{ backgroundColor: "#F9FAFF" }}>
                          <td>#TXN003</td>
                          <td>Sunset Cottage</td>
                          <td>₹1 Crore</td>
                          <td>12 October 2024</td>
                          <td>Bank Transfer</td>
                          <td>Successful</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="pills-contact"
                    role="tabpanel"
                    aria-labelledby="pills-contact-tab"
                  >
                    {" "}
                    <table
                      className="table table-striped"
                      style={{ border: "1px solid #FFFFFF", borderRadius: 10 }}
                    >
                      <thead style={{ backgroundColor: "#D9D9D9" }}>
                        <tr>
                          <th
                            style={{
                              backgroundColor: "#F9FAFF",
                              color: "#232859",
                              textTransform: "none",
                              fontSize: 16
                            }}
                          >
                            Payment History
                          </th>
                          <th
                            style={{
                              backgroundColor: "#F9FAFF",
                              color: "#232859",
                              textTransform: "none"
                            }}
                          ></th>
                          <th
                            style={{
                              backgroundColor: "#F9FAFF",
                              color: "#232859",
                              textTransform: "none"
                            }}
                          ></th>
                          <th
                            style={{
                              backgroundColor: "#F9FAFF",
                              color: "#232859",
                              textTransform: "none"
                            }}
                          ></th>
                          <th
                            style={{
                              backgroundColor: "#F9FAFF",
                              color: "#232859",
                              textTransform: "none"
                            }}
                          ></th>
                          <th
                            style={{
                              backgroundColor: "#F9FAFF",
                              color: "#232859",
                              textTransform: "none"
                            }}
                          ></th>
                        </tr>
                        <tr>
                          <th style={{ color: "#fff", backgroundColor: "#8C8FA7" }}>
                            Transaction ID
                          </th>
                          <th style={{ color: "#fff", backgroundColor: "#8C8FA7" }}>
                            Property Name
                          </th>
                          <th style={{ color: "#fff", backgroundColor: "#8C8FA7" }}>
                            Amount Paid
                          </th>
                          <th style={{ color: "#fff", backgroundColor: "#8C8FA7" }}>
                            Payment Date
                          </th>
                          <th style={{ color: "#fff", backgroundColor: "#8C8FA7" }}>
                            Payment Method
                          </th>
                          <th style={{ color: "#fff", backgroundColor: "#8C8FA7" }}>
                            Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr style={{ backgroundColor: "#F9FAFF" }}>
                          <td>#TXN001</td>
                          <td>Sunset Cottage</td>
                          <td>₹1 Crore</td>
                          <td>12 October 2024</td>
                          <td>Bank Transfer</td>
                          <td>Successful</td>
                        </tr>
                        <tr style={{ backgroundColor: "#F9FAFF" }}>
                          <td>#TXN002</td>
                          <td>Sunset Cottage</td>
                          <td>₹1 Crore</td>
                          <td>12 October 2024</td>
                          <td>Bank Transfer</td>
                          <td>Successful</td>
                        </tr>
                        <tr style={{ backgroundColor: "#F9FAFF" }}>
                          <td>#TXN003</td>
                          <td>Sunset Cottage</td>
                          <td>₹1 Crore</td>
                          <td>12 October 2024</td>
                          <td>Bank Transfer</td>
                          <td>Successful</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div> */}



          </div>
        </div>

      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeUserModal}
        contentLabel="User Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <ViewBooking investment={selectedUser} closeModal={closeUserModal} />
      </Modal>
    </div>
  );
}

export default ViewEarning;
